export default __webpack_public_path__ + "static/media/btn-skip-on.c5f62e15.png";